import { useEffect, useState } from "react";
import is from "@sindresorhus/is";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Paper";
import { useTheme } from "@mui/material/styles";

import Logo from "../Logo/Logo";

import actions from "../../../data/actions";

const Contact = props => {
  const theme = useTheme();

  const [addressPost, setAddressPost] = useState();
  // const [clinicPost, setClinicPost] = useState();
  const [emailPost, setEmailPost] = useState();
  const [loaded, setLoaded] = useState(false);
  const [openingHoursPost, setOpeningHoursPost] = useState();
  const [phoneNumberPost, setPhoneNumberPost] = useState();

  const bgcolor = theme.palette.background.footer;
  const color = theme.palette.getContrastText(bgcolor);

  // (init) -> addresses, phoneNumbers
  useEffect(() => {
    Promise.resolve()
      .then(() => actions.getAddressPost())
      .then(post => is.plainObject(post) && setAddressPost(post))
      // .then(() => actions.getClinicPost())
      // .then(post => is.plainObject(post) && setClinicPost(post))
      .then(() => actions.getEmailPost())
      .then(post => is.plainObject(post) && setEmailPost(post))
      .then(() => actions.getOpeningHoursPost())
      .then(post => is.plainObject(post) && setOpeningHoursPost(post))
      .then(() => actions.getPhoneNumberPost())
      .then(post => is.plainObject(post) && setPhoneNumberPost(post))
      .then(() => setLoaded(true))
      .catch(error => console.log(error));
  }, []);

  return (
    <Paper elevation={0} square sx={{ bgcolor, color }}>
      <Container disableGutters maxWidth="lg" sx={{ pt: 4, pb: 8, px: 2 }}>
        {loaded ? (
          <>
            <Box sx={{ pb: 4, px: 1 }}>
              <Logo dark mono width={200} />
            </Box>
            <Grid container spacing={{ xs: 0, sm: 8 }} sx={{ alignItems: "top", justifyContent: "center", px: 1 }}>
              <Grid container item xs={12} sm={6}>
                {is.plainObject(openingHoursPost) && (
                  <Grid item xs={12}>
                    <Typography component="div" variant="h6" sx={{ bgcolor, color: theme.palette.primary.main, pb: 1 }}>
                      {openingHoursPost.title}
                    </Typography>
                    {openingHoursPost.content.html}
                  </Grid>
                )}
              </Grid>
              <Grid container item xs={12} sm={6}>
                {is.plainObject(addressPost) && (
                  <Grid item xs={12} sx={{ py: 1 }}>
                    <Typography component="div" variant="h6" sx={{ bgcolor, color: theme.palette.primary.main }}>
                      {addressPost.title}
                    </Typography>
                    {addressPost.content.plain.map((line, index) => (
                      <Typography component="div" key={index} variant="body1" sx={{ bgcolor }}>
                        {line}
                      </Typography>
                    ))}
                  </Grid>
                )}
                {is.plainObject(phoneNumberPost) && (
                  <Grid item xs={12} sx={{ py: 1 }}>
                    <Typography component="div" variant="h6" sx={{ bgcolor, color: theme.palette.primary.main }}>
                      {phoneNumberPost.title}
                    </Typography>
                    {phoneNumberPost.content.plain.map((line, index) => (
                      <Typography component="div" key={index} variant="body1" sx={{ bgcolor }}>
                        {line}
                      </Typography>
                    ))}
                  </Grid>
                )}
                {is.plainObject(emailPost) && (
                  <Grid item xs={12} sx={{ py: 1 }}>
                    <Typography component="div" variant="h6" sx={{ bgcolor, color: theme.palette.primary.main }}>
                      {emailPost.title}
                    </Typography>
                    {emailPost.content.plain.map((line, index) => (
                      <Typography component="div" key={index} variant="body1" sx={{ bgcolor }}>
                        {line}
                      </Typography>
                    ))}
                  </Grid>
                )}
              </Grid>
            </Grid>
          </>
        ) : null}
      </Container>
    </Paper>
  );
};

export default Contact;
